<template>
  <div class="pdf-preview">
    <PDFDocument
      class="pdf-document"
      :url="url"
      :pdf_data="pdf_data"
      :currentPage="currentPage"
      :numPages="numPages"
      :scale="scale"
      :inputPage="inputPage"
      iluminateCurrent
      numberPage
      @goToPage="goToPage"
    ></PDFDocument>
  </div>
</template>

<script>
import PDFDocument from '@/components/pdf_viewer/new_components/PDFDocument';
export default {
  name: 'PDFPreviewer',
    props: {
      url: {
        type: String
      },
      pdf_data: {
        type: ArrayBuffer
      },
      currentPage: {
        type: Number,
        default: 0
      },
      numPages: {
        type: Number,
        default: 0
      },
      inputPage: {
        type: Number,
        default: 0
      },
    },
    components: {
      PDFDocument,
    },
    data() {
      return {
        scale: 0.25,
      }
    },

    methods: {
      goToPage(page) {
        this.$emit('goToPage', page);
      },
    },
    watch: {
    }
}
</script>
<style lang="scss">
@import "@/sass/pdf.scss";
</style>